import Vue from 'vue'
import App from './App.vue'
import router from './router'
import instance from './axios.config'
import store from './store'
import i18n from './lang'
import "swiper/css/swiper.min.css"
import "./assets/css/animate.min.css"
import Vant from 'vant'
import 'vant/lib/index.css'
import VueWechatTitle from 'vue-wechat-title';
import getPageTitle from "@/utils/get-page-title";
import cookies from 'vue-cookies'
/*import VConsole from 'vconsole';
new VConsole();*/

Vue.use(VueWechatTitle)

Vue.use(Vant)
Vue.config.productionTip = false
if (!localStorage.getItem('userId')) {
  router.push('/login')
}

Vue.prototype.$ajax = instance
Vue.prototype.$cookies = cookies;
router.beforeEach((to, from, next) => {
  document.title = getPageTitle(to.meta.title)
  const token = localStorage.getItem('token')
  Vue.prototype.upFileUrl = localStorage.getItem("upFileUrl");
/*  if (localStorage.getItem("isSafePwd") === "false" && to.name !== "editPass"&& to.name !== "login") {
    next("/editPass")
    return
  }*/
  if (!token && to.path !== "/login" && to.path!== "/resetPwd" && to.path!== "/Register" && to.path!== "/myExplain"&& to.path!== "/Help") {
    next("/login")
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')


